/* eslint-disable no-unused-vars */
import * as S from './TargetingOngoingBrandsModels.styled';
import { Buttons, Separator, TypeOfItem, ErrorForBtn, RadioBox, Label } from 'components';
import { useSelector } from 'react-redux';
import { selectTargettingErrorFlag } from 'store/selectors';
import ChooseBrandsModelBtn from './chooseBrandsModelBtn/ChooseBrandsModelBtn';
import SectionLayout from 'components/common/SectionLayout';
import { useFacade } from './useFacade';
import { RadioBoxGroup, RightSideContainer } from '../../components';
import { alphabeticallySort } from 'utils';

export default function TargetingOngoingBrandsModels() {
  const selectedType = useSelector((state) => state.targetingBrandsModels.type);
  const errorFlag = useSelector(selectTargettingErrorFlag);
  const {
    deleteIncAction,
    deleteExcAction,
    initExcModels,
    initIncBrandsModels,
    counterOrBrandToData,
    clearAllExc,
    handleChange,
  } = useFacade(selectedType);

  return (
    <>
      <SectionLayout
        noSeparator={true}
        noBottomPadding={true}
        leftSide={<Label text='Brands & Models:' variant='label' style={{ marginTop: '8px' }} />}
        rightSide={
          <RightSideContainer>
            <RadioBoxGroup>
              <RadioBox.NormalSize
                onChange={handleChange}
                label='All Brands'
                width={112}
                variant='left'
                value='all_brands'
                pressed={selectedType === 'all_brands'}
              />
              <RadioBox.NormalSize
                onChange={handleChange}
                label='Specific Brands & Models'
                width={207}
                variant='right'
                value='specific_brands_models'
                pressed={selectedType === 'specific_brands_models'}
              />
            </RadioBoxGroup>
            {/* brands_audience_to_save:{JSON.stringify(brands_audience_to_save)} */}
            {selectedType !== 'all_brands' && (
              <>
                <S.MultipleItemsSelectionComponent showErrorBorder={errorFlag.devices}>
                  <S.FlexColumn3>
                    <ChooseBrandsModelBtn />
                  </S.FlexColumn3>
                  {initIncBrandsModels.length ? (
                    <>
                      <Separator />
                      <S.SelectedItems>
                        <S.ClearBtnSection>
                          <label>Include:</label>
                          <Buttons.TertiaryNormal
                            id='inc_clear_all'
                            onClick={(e) => clearAllExc(e.target.id)}
                          >
                            Clear All
                          </Buttons.TertiaryNormal>
                        </S.ClearBtnSection>
                        <S.MyBox>
                          <S.MyGrid container>
                            {initIncBrandsModels.map((inc) => (
                              <TypeOfItem
                                key={inc}
                                item={counterOrBrandToData[inc]}
                                deleteIncAction={deleteIncAction}
                              />
                            ))}
                          </S.MyGrid>
                        </S.MyBox>
                      </S.SelectedItems>
                    </>
                  ) : null}
                  {initExcModels.length ? (
                    <>
                      <Separator />
                      <S.SelectedItems>
                        <S.ClearBtnSection>
                          <label>Exclude:</label>
                          <Buttons.TertiaryNormal
                            id='exc_clear_all'
                            onClick={(e) => clearAllExc(e.target.id)}
                          >
                            Clear All
                          </Buttons.TertiaryNormal>
                        </S.ClearBtnSection>
                        <S.MyBox>
                          <S.MyGrid container>
                            {initExcModels.map((exc) => (
                              <TypeOfItem
                                key={exc}
                                item={counterOrBrandToData[exc]}
                                deleteIncAction={deleteIncAction}
                                deleteExcAction={deleteExcAction}
                                exclude
                              />
                            ))}
                          </S.MyGrid>
                        </S.MyBox>
                      </S.SelectedItems>
                    </>
                  ) : null}
                </S.MultipleItemsSelectionComponent>
                <ErrorForBtn
                  errorMsg='Please choose Brands and Models or select "All Brands".'
                  isOpen={errorFlag.devices}
                />
              </>
            )}
          </RightSideContainer>
        }
      />
      <Separator />
    </>
  );
}
